//
//  ElementProperty.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
import { ElementPropertyOption, } from "./SDKElementPropertyOption";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var ElementPropertyType;
(function (ElementPropertyType) {
    ElementPropertyType["text"] = "Text";
    ElementPropertyType["number"] = "Number";
    ElementPropertyType["boolean"] = "Boolean";
    ElementPropertyType["select"] = "Select";
    ElementPropertyType["generic"] = "Generic";
    ElementPropertyType["link"] = "Link";
    ElementPropertyType["url"] = "URL";
})(ElementPropertyType || (ElementPropertyType = {}));
export var ElementPropertyTargetElementType;
(function (ElementPropertyTargetElementType) {
    ElementPropertyTargetElementType["token"] = "Token";
    ElementPropertyTargetElementType["component"] = "Component";
    ElementPropertyTargetElementType["documentationPage"] = "DocumentationPage";
})(ElementPropertyTargetElementType || (ElementPropertyTargetElementType = {}));
export var ElementPropertyLinkElementType;
(function (ElementPropertyLinkElementType) {
    ElementPropertyLinkElementType["documentationItem"] = "DocumentationPage";
    ElementPropertyLinkElementType["figmaComponent"] = "FigmaComponent";
})(ElementPropertyLinkElementType || (ElementPropertyLinkElementType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ElementProperty {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.idInVersion = model.id;
        this.id = model.persistentId;
        this.designSystemVersionId = model.designSystemVersionId;
        this.name = model.meta.name;
        this.codeName = model.codeName;
        this.description = (_a = model.meta.description) !== null && _a !== void 0 ? _a : null;
        this.propertyType = model.type;
        this.isImmutable = model.isImmutable;
        this.targetElementType = model.targetElementType;
        this.linkElementType = (_b = model.linkElementType) !== null && _b !== void 0 ? _b : null;
        this.options = model.options
            ? model.options.map((o) => new ElementPropertyOption(o))
            : [];
    }
    /** Constructs directly manipulable update object */
    toUpdateObject() {
        var _a, _b;
        return {
            name: this.name,
            description: (_a = this.description) !== null && _a !== void 0 ? _a : "",
            codeName: this.codeName,
            options: ((_b = this.options) !== null && _b !== void 0 ? _b : []).map((o) => o.toUpdateObject()),
        };
    }
}
